<template>
  <div
    class="custom-faqs"
    :class="[variant]"
    :key="faq.value"
    v-for="(faq, index) in faqs"
    @click="(event) => toggle(event, index)"
  >
    <div
      class="accordion"
      :class="[selectedFaq.value === index && 'faqs-single-active', variant]"
    >
      <div class="header">
        <h2 class="faqs-question flex-95">
          {{ faq.question }}
        </h2>
        <div class="arrow-icon flex-05">
          <img
            src="/images/icons/arrow-icon.svg"
            class="arrow"
            loading="lazy"
            width="24"
            height="25"
            alt="arrow icon"
          />
        </div>
      </div>
      <transition
        name="accordion"
        v-on:before-enter="beforeEnter"
        v-on:enter="enter"
        v-on:before-leave="beforeLeave"
        v-on:leave="leave"
      >
        <div class="body" v-show="active(index)">
          <div class="body-inner">
            <div id="app">
              <p class="faqs-answer" v-html="faq.answer"></p>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { Transition } from "vue";

export default {
  data() {
    return {
      selectedFaq: {
        value: null,
      },
      show: false,
    };
  },

  props: {
    faqs: {
      default: {},
    },
    className: String,

    variant: {
      type: String,
      default: "default",
    },
  },

  components: {
    Transition,
  },
  methods: {
    toggle(event, index) {
      if (
        event.target.classList.contains("faqs-answer") ||
        event.target.classList.contains("open_intercom_link") ||
        event.target.href
      ) {
      } else {
        this.selectedFaq.value =
          this.selectedFaq.value === index ? null : index;
      }
    },
    beforeEnter: function (el) {
      el.style.height = "0";
    },
    enter: function (el) {
      el.style.height = el.scrollHeight + "px";
    },
    beforeLeave: function (el) {
      el.style.height = el.scrollHeight + "px";
    },
    leave: function (el) {
      el.style.height = "0";
    },
    doNothing(e) {},
    active(index) {
      if (index === this.selectedFaq.value) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style scoped>
.accordion {
  position: flex;
  width: 100%;
  height: auto;
  cursor: pointer;
}

.accordion .header {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.arrow-icon {
  width: 36px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.accordion .body {
  /*   display: none; */
  overflow: hidden;
  transition: 250ms ease-out;
}
</style>
